import { getUserConfiguration } from 'owa-session-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import inboxPlusStore from 'owa-mail-inbox-plus-store/lib/store/Store';

export default function getWatermarkForInboxClassificationFilter(
    inboxClassificationFilter: InboxClassificationFilter
): string {
    const enabledPivots = inboxPlusStore.inboxPlusPivots
        .filter(pivot => pivot.isEnabled)
        .map(pivot => pivot.InboxClassificationFilter);

    const watermarkIndex = enabledPivots.indexOf(inboxClassificationFilter);
    return getUserConfiguration().UserOptions.InboxPlusWatermarks[watermarkIndex];
}
